<template lang="pug">
	
	div#componentZoomSelect(v-if="currentZoom")
		div(@click="showOptions = !showOptions", :class="{active : showOptions}")
			i.fa.i.fa.fa-search.mr-1
			span.mr-2 Zoom: {{mapZoom}}
			i.fa.fa-angle-up

		transition(name="el-zoom-in-bottom")

			div#options(v-show="showOptions")
				
				div.h-100
					
					span.title Zoom

					div.d-flex.justify-content-center.mt-3
						el-slider(v-model="currentZoom", vertical, v-if="showOptions"
							:min="minZoom", :max="maxZoom", @change="updateZoom")
</template>

<script>

export default {

	name: 'ZoomSelect',

	data () {
		return {
			currentZoom: null,
			showOptions: false,
			selectedBaseMap: null
		};
	},

	methods: {
		
		updateZoom (zoom) {

			this.$bus.$emit('mapa.changeZoom', zoom);
			this.showOptions = false;
		}
	},

	computed: {

		mapZoom () {
		
			return this.$store.state.mapa.zoom;
		},

		minZoom () {
		
			return this.$store.state.mapa.minZoom;
		},

		maxZoom () {
		
			return this.$store.state.mapa.maxZoom;
		}
	},

	mounted () {
		
		this.currentZoom = this.mapZoom;
		
		this.selectedBaseMap = _.find(this.baseMaps, (baseMap) => {
			return baseMap.default;
		});

		this.$store.watch(this.$store.getters.mapaZoom, (z) => {
			this.currentZoom = z;
		});
	}
};

</script>

<style lang="scss">

@import "../styles/mixins.scss";
@import '../styles/variaveis';

#componentZoomSelect {
	
	color: $zoom-select-color;
	background-color: $zoom-select-bg;
	height: 100%;
	cursor: pointer;

	#options {

		background: $zoom-select-options-bg;
		color: $zoom-select-options-color;
		border-radius: $default-border-radius;
		@include box-shadow(0px, 3px, 6px, rgba(0,0,0,0.16)); //TODO: Extrair
		position: absolute;
		bottom: $bottom-bar-height + 1;
		right: 0;
		width: 100px;
		height: 200px;

		.title {
			display: block;
			text-align: center;
			width: 100%;
			padding: 0.25rem 1.5rem;
			font-weight: 600;
			font-size: $zoom-select-title-font-size;
			border-bottom: 1px solid $zoom-select-title-border-color;
			cursor: default;
		}
	}

	&:hover, .active {
		color: $zoom-select-active-color;
	}

	.el-slider {
		height: $zoom-select-options-slider-height;
	}
}

</style>



// WEBPACK FOOTER //
// ZoomSelect.vue?105d5888